import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject, ViewChild } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { AppService } from 'src/app/services/app/app.service';
import { Filter } from '../../filter/filter.model';
import { CommonService } from 'src/app/services/common/common.service';
import { AlertComponent } from '../../alert/alert.component';
import { MatStepper } from '@angular/material/stepper';
import { PaginationInstance } from 'ngx-pagination';
// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'YYYY-MM-DD',
//   },
//   display: {
//     dateInput: 'YYYY-MM-DD',
//     monthYearLabel: 'MMMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY'
//   },
// };
@Component({
  selector: 'app-assign-course',
  templateUrl: './assign-course.component.html',
  styleUrls: ['./assign-course.component.scss'],
  // providers: [
  //   { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  // ]
})
export class AssignCourseComponent {
  assignFormGroup = this._formBuilder.group({
    manager_id: ['', Validators.required],
    isManager: ['1'],
    isPublish: ['1'],
    training_date: [''],
    training_time: [''],
    deadline_date: ['', Validators.required],
    deadline_time: [''],
    is_builder: [''],
    is_editable: [''],
    course_id: [''],
    isNotifyEmployee: [''],
    notification_msg: [''],
    isScheduleRemoval: [''],
    removeapp: [''],
    remove_date: [''],
    remove_time: [''],
    isSendReminder: [''],
    reminder_date: [''],
    reminder_time: [''], 
    reminder: [''],
    department_id: ['']
  });
  selectedTime!: string;
  isFirstStepClicked: boolean = false;
  public maxPaginationSize = GlobalService.maxPaginationSize
  @ViewChild('picker') picker!: any;
  public displayedColumnsEmp: string[] = ['select', 'first_name', 'department', 'phone_number'];
  public dataSourceEmp = new MatTableDataSource();
  public countEmp!: any;
  public imageURL: any = GlobalService.imageURL;
  pageIndex = 0;
  pageSize = 15;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  @ViewChild('sortEmp') sortEmp!: MatSort;
  @ViewChild(MatPaginator) paginatorEmp!: MatPaginator;
  public isSelectAll: boolean = false;
  public departmentArr: any[] = [];
  public managerArr: any[] = [];
  dropdownSettings: IDropdownSettings = {};
  selectedElements: any[] = [];
  public courseData: any;
  minDate = new Date()
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  onSearchS:boolean = false;
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "first_name", type: 'text' },
    { key_name: "Last Name", key_val: "last_name", type: 'text' },
    { key_name: "Email", key_val: "email", type: 'text' },
  ]
  public playListUse!:any;
  public playListError!:string;
  public isPlayListAssign:boolean=false;
  @ViewChild('stepper') stepper !: MatStepper;
  public searchInput: string = '';
  private previousInputValue: string = '';
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };

  constructor(private _formBuilder: FormBuilder, private _liveAnnouncer: LiveAnnouncer, private userManagementService: UserManagementService, private datePipe: DatePipe,
    private spinner: NgxSpinnerService, private courseService: CourseService, @Inject(MAT_DIALOG_DATA) public dialogData: any, private appService: AppService,
    public dialogRef: MatDialogRef<AssignCourseComponent>, private commonService: CommonService,public dialog: MatDialog,private dateAdapter: DateAdapter<Date>) { 
      this.dateAdapter.setLocale('en-GB');
    }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.dropdownSettings = {
      idField: 'id',
      textField: 'department_name',
      allowSearchFilter: true
    };
    if(this.dialogData && this.dialogData.data["dataType"]=="Assign Playlist"){
      this.isPlayListAssign=true;
      this.getPlaylistUse();
    }
    // this.empList(this.pageSize, 0);
    this.onManagerList();
    this.getDepartmentList();
    this.validationForm('assignFormGroup', 'isPublish', 'training_date')
    this.validationForm('assignFormGroup', 'isPublish', 'training_time')
    this.validationForm('assignFormGroup', 'isScheduleRemoval', 'remove_date')
    this.validationForm('assignFormGroup', 'isScheduleRemoval', 'remove_time')
    this.validationForm('assignFormGroup', 'isSendReminder', 'reminder_date')
    this.validationForm('assignFormGroup', 'isSendReminder', 'reminder_time')
    this.validationForm('assignFormGroup', 'isNotifyEmployee', 'notification_msg')
    this.validationForm2('assignFormGroup', 'isManager', 'manager_id')
    this.validationForm2('assignFormGroup', 'isManager', 'department_id')
    this.onPageChange(1)

  }
  validationForm(formName, getElement, setElement) {
    this[formName].get(getElement).valueChanges.subscribe(val => {
      if ((getElement == 'isPublish' && val == '0') || (getElement == 'isScheduleRemoval' && val == true)
        || (getElement == 'isSendReminder' && val == true) || (getElement == 'isNotifyEmployee' && val == true)) {
        this[formName].controls[setElement].setValidators([Validators.required]);
      }
      else {
        this[formName].controls[setElement].clearValidators();
        this[formName].controls[setElement].setErrors(null);
      }
      this[formName].controls[setElement].updateValueAndValidity();
    })
  }

  validationForm2(formName, getElement, setElement) {
    this[formName].get(getElement).valueChanges.subscribe(val => {
      if ( (getElement == 'isManager' && val == 1)) {
        this[formName].controls['manager_id'].setValidators([Validators.required]);
        this[formName].controls['department_id'].clearValidators();
      }
      else {
        this[formName].controls['department_id'].setValidators([Validators.required]);
        this[formName].controls['manager_id'].clearValidators();
      }
      this[formName].controls[setElement].updateValueAndValidity();
    })
  }

  get getControls() {
    return this.assignFormGroup.controls;
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
  }
  callApi(obj) {
    this.filterObj = obj
    this.empList(this.pageSize, 0);
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.empList(this.pageSize, 0);
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.empList(this.pageSize, 0);
  }
  onPageEvent = (event: any) => {
    this.pageIndex = event.pageIndex;

    this.pageSize = event.pageSize;
    let startPage = (event.pageIndex) * (event.pageSize) + 1;
    if (this.pageIndex == 0) {
      startPage = 0;
    }
    this.empList(this.pageSize, startPage)
  }
  empList = (pageSize: number, size: number): void => {
    this.dataSourceEmp.data = []
    this.spinner.show();
    let obj;
  
       obj = {
        st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        r_p: this.config.itemsPerPage,
        f_a: this.filterObj.arr,
        op_nd: this.filterObj.operand,
        sh: this.searchInput.trim(),
        pl_id:"",
      }
      
    if(this.isPlayListAssign==true){
      obj["pl_id"]=this.dialogData.data["pl_id"]
    }
    this.userManagementService.empList(obj).subscribe({
        next: (success: any) => {
          this.previousInputValue=this.searchInput
          this.spinner.hide()
          success.data.employee_list.map((item: any) => item.first_name = this.capitalizeFirstLetter(item.first_name))
          this.dataSourceEmp = new MatTableDataSource(success.data.employee_list)
          this.dataSourceEmp.data.map((item: any) => { item["selected"] = "" })

          this.countEmp = success.count
          this.dataSourceEmp.sort = this.sortEmp;
          this.dataSourceEmp.paginator = this.paginatorEmp;


          if (this.isSelectAll == true) {
            this.dataSourceEmp.data.map((item: any) => { item["selected"] = true })
          }
          if (this.selectedElements.length > 0) {
            this.dataSourceEmp.data.map((dataItem: any) => {
              const matchedSelected = this.selectedElements.find((selectedItem) => selectedItem.employee_id === dataItem.employee_id);
              dataItem.selected = !!matchedSelected;
              return dataItem;
            });
          }
          // Assuming you have two arrays named `array1` and `array2`

        },
        error: (error: any) => {
          this.spinner.hide()
          this.previousInputValue=this.searchInput
          this.commonService.handleError(error)
        }
      }
    );
  }
  capitalizeFirstLetter(text: string) {
    if (text != '' || text != null) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    else {
      return text;
    }
  }
  onSelectAll(event) {
    if (event.checked) {
      this.dataSourceEmp.data.forEach((item: any) => {
        item.selected = true;
        if (!this.selectedElements.includes(item)) {
          this.selectedElements.push(item);
        }
      });
      this.isSelectAll = true;
    } else {
      this.dataSourceEmp.data.forEach((item: any) => {
        item.selected = false;
        this.selectedElements = this.selectedElements.filter((selectedItem) => selectedItem !== item);
      });
      this.isSelectAll = false;
    }
  }
  onSelectSingle(event, element) {
    if (event.checked) {
      element.selected = true;
      this.selectedElements.push(element);
    } else {
      element.selected = false;
      this.selectedElements = this.selectedElements.filter((selectedItem) => selectedItem !== element);
    }
    const selectedCount = this.dataSourceEmp.data.filter((item: any) => item.selected).length;
    this.isSelectAll = selectedCount === this.dataSourceEmp.data.length;
  }
  onAssignSubmit() {
    if (!this.assignFormGroup.valid) {
      this.assignFormGroup.markAllAsTouched()
    }
    else {
      let isPublish: any = this.assignFormGroup.get("isPublish")?.value
      if (isPublish == 1) {
        this.assignFormGroup.get("training_date")?.setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'))
        this.assignFormGroup.get("training_time")?.setValue(this.datePipe.transform(new Date(), 'hh:mm'))
      }
    }
  }
  onFirstNextClick() {
    
    this.playListError='';
    if(this.isPlayListAssign){
      // if(this.playListUse==0){}
      if(this.playListUse==0){
        this.isFirstStepClicked=true
        this.stepper.next()
      }
      else{
        if(((this.selectedElements.length <= this.playListUse) ||(this.playListUse=='no limit'))){
          this.isFirstStepClicked=true;
          this.stepper.next()
        }
        else{
         this.playListError="Playlist assigning"
         this.showAlert('')
        }
      }
    
    }
    else{
      this.isFirstStepClicked = true;
      this.stepper.next()
    }
  }
  onSubmitAssign(){
    let empId: any[] = []
    for (let i = 0; i < this.selectedElements.length; i++) {
      if (this.selectedElements[i]['selected'] == true) {
        empId.push(this.selectedElements[i]['employee_id'])
      }
    }
    let obj: {} = {
      "ma_i": this.assignFormGroup.get("manager_id")?.value,
      "tr_dt": this.datePipe.transform(this.assignFormGroup.get("training_date")?.value, 'yyyy-MM-dd'),
      "tr_ti": this.assignFormGroup.get("training_time")?.value,
      "de_dt": this.datePipe.transform(this.assignFormGroup.get("deadline_date")?.value, 'yyyy-MM-dd'),
      "de_ti": "00:00",
      "pc_id": this.dialogData["data"]["package_course_id"],
      "is_build": this.dialogData["data"]["is_builder"],
      "is_e": this.dialogData["data"]["is_editable"],
      "c_i": this.dialogData["data"]["course_id"],
      "rem": this.datePipe.transform(this.assignFormGroup.get("reminder_date")?.value, 'yyyy-MM-dd') + ' ' + this.assignFormGroup.get("reminder_time")?.value,
      "rea": this.datePipe.transform(this.assignFormGroup.get("remove_date")?.value, 'yyyy-MM-dd') + ' ' + this.assignFormGroup.get("remove_time")?.value,
      "noti_m": this.assignFormGroup.get("notification_msg")?.value,
      "em_i": empId,
      "d_i": this.assignFormGroup.value?.department_id,
       "t":this.dialogData["data"]["t"]
    }
    if (this.isSelectAll) {
      obj["em_i"] = "selectall"
    }
    if(this.isPlayListAssign){
      this.onSubmitAssignPlaylist(obj)
    }
    else{
      this.onSubmitAssignCourse(obj)
    }
  }
  onSubmitAssignCourse(obj) {
    this.spinner.show()
    this.courseService.assignCourse(obj).subscribe({
      next: (data: any) => {
        this.spinner.hide()
        if (data["status"] == 200) {
          this.appService.showToastMessage('success', data["msg"])
          this.dialogRef.close({ course_assigned: true })
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onSubmitAssignPlaylist(obj) {
    this.spinner.show()
    obj["pl_id"]=this.dialogData.data["pl_id"]
    this.courseService.assignPlaylist(obj).subscribe({
      next: (data: any) => {
        this.spinner.hide()
        if (data["status"] == 200) {
          this.appService.showToastMessage('success', data["msg"])
          this.dialogRef.close({ course_assigned: true })
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onManagerList() {
    this.userManagementService.managerListAll().subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide()
            this.managerArr = success.data;
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error)
        }}
    );
  }
  getDepartmentList() {
    this.departmentArr = []
    this.courseService.getDepartmentList().subscribe({
        next: (success: any) => {
          if (success["status"] == 200) {
            this.departmentArr = success["data"];
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error)
        }})
  }
  onClose() {
    this.dialogRef.close()
  }
  getPlaylistUse(){
    let data={
      "pl_id":this.dialogData.data["pl_id"]
    }
    this.courseService.getUsePlaylist(data).subscribe({
      next:(success:any)=>{
        if(success.status==200){
          this.playListUse=success.msg.use
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  showAlert(type) {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: 'assign_playlist', }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // if (result["delete_content"] == true) {
        // this.onCourseList()
        // }
      }
    });
  }


  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.onSearchS = true;
      this.config.currentPage = 0
      this.empList(this.pageSize, 0);
    }
   
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.onSearchS = true;
      this.config.currentPage = 0
      this.empList(this.pageSize, 0);
      
    }
    
    }
  
}